import { createContext } from 'react'
import type { I18n } from '@lingui/core'

export const ServerContext = createContext<null | {
  defaultBreakpoint: number
  timeZone?: string
  locale?: string
  i18n?: I18n
}>(null)
